import { ApplicationData } from './application-data';
import { Validator } from './validator';

export class SchoolValidator implements Validator {
    public validate(data: ApplicationData): boolean {
        return typeof data.school !== 'undefined' && data.school !== null;
        
    }
}
